(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lender-integration', {
            parent: 'entity',
            url: '/lender-integration?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.lenderIntegration.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lender-integration/lender-integrations.html',
                    controller: 'LenderIntegrationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('lenderIntegration');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('lender-integration-detail', {
            parent: 'entity',
            url: '/lender-integration/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.lenderIntegration.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lender-integration/lender-integration-detail.html',
                    controller: 'LenderIntegrationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('lenderIntegration');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LenderIntegration', function($stateParams, LenderIntegration) {
                    return LenderIntegration.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('lender-integration.new', {
            parent: 'lender-integration',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lender-integration/lender-integration-dialog.html',
                    controller: 'LenderIntegrationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                integrationName: null,
                                hashKey: null,
                                disabled: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('lender-integration', null, { reload: true });
                }, function() {
                    $state.go('lender-integration');
                });
            }]
        })
        .state('lender-integration.edit', {
            parent: 'lender-integration',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lender-integration/lender-integration-dialog.html',
                    controller: 'LenderIntegrationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LenderIntegration', function(LenderIntegration) {
                            return LenderIntegration.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('lender-integration', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lender-integration.delete', {
            parent: 'lender-integration',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lender-integration/lender-integration-delete-dialog.html',
                    controller: 'LenderIntegrationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LenderIntegration', function(LenderIntegration) {
                            return LenderIntegration.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('lender-integration', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
